<template>

  <CenterCenter>
    <div class="main">
      <div class="numberError">
        {{ $t('notFoundPage.sad') }}
      </div>
      <div class="text">
        {{ $t('notFoundPage.title') }}
        <br/>{{ $t('notFoundPage.number') }}
      </div>
    </div>
  </CenterCenter>

</template>

<script lang="ts">
import CenterCenter from '@/components/layout/CenterCenter.vue';
import {Component, Vue} from 'vue-property-decorator';
import {setPageEvent} from '@/utils/tracker';
import {PageEvent} from '@/enum/TrackerEnum';

@Component({
  components: {CenterCenter},
})
export default class NotFoundView extends Vue {

  private mounted() {
    setPageEvent(PageEvent.page_404, {url_not_found: document.location.href});
  }
}
</script>

<style scoped lang="scss">

.main {
  padding-top: 32px;
  max-width: 700px;
  width: 100%;
  height: 100%;

  .numberError {
    font-size: 172px;
  }

  .text {
    font-size: 32px;
  }
}

</style>
